import React, { useState, useEffect } from 'react';
import { Box, Card, CardContent, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { CustomWidthTooltip } from '../utils/customWidthToolTipUtil';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { toast } from 'react-toastify';

const BaselinesCard = ({ title }) => {
  
  const [baselines, setBaselines] = useState([]);
  
  const onToggle = (item, event) => {
    toast.success(`Baseline Process Initiated`);
  }

  const toolTip = "Newly deployed sensors are listed here. Activating the toggle initiates the 24-hour baseline process, after which any new systems or applications will be categorized as rogue and you have to authorize them";

  useEffect(() => {
      setBaselines([{ id: 1, sensor: 'sensor-001', initialized: false }, { id: 2, sensor: 'sensor-002', initialized: false }]);
    }, []);

  return (
    <Card sx={{ width: 400, backgroundColor: 'transparent' }}>
      <CardContent sx={{ p: 2 }}>
        <Typography variant="h5" sx={{ color: 'white', mb: 2, fontWeight: 'bold' }}>
          {title}
          <CustomWidthTooltip title={ toolTip } placement="top" dynamicWidth="400px" dyanmicHeight="25px" showPhen='true'>
              <HelpOutlineIcon sx={{ '&:hover': { cursor: 'pointer' }, ml: 2 }}/>
          </CustomWidthTooltip>
        </Typography>
        <Box sx={{ display: 'flex', borderRadius: '4px 4px 0 0', overflow: 'hidden' }}>
          <Box
            sx={{
              backgroundColor: '#1976d2',
              width: `200px`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '0.875rem',
              py: 1,
            }}
          >
            Sensor
          </Box>
          <Box
            sx={{
              backgroundColor: '#1976d2',
              width: `200px`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '0.875rem',
              py: 1,
            }}
          >
            Initialized
          </Box>
        </Box>
        
        <Box sx={{ display: 'flex', borderRadius: '0 0 4px 4px', overflow: 'hidden' }}>
          <TableContainer>
            <Table sx={{ minWidth: 250 }} size="small" aria-label="simple table">
              <TableBody>
                  {baselines.map((item) => (
                      <TableRow key={item.id} 
                        sx={{ height: 25, backgroundColor: '#4caf50' }}
                      >
                        <TableCell sx={{ color: '#FFFFFF' }}>{item.sensor}</TableCell>
                        <TableCell sx={{ backgroundColor: '#f44336' }}> <Switch checked={!!item.initialized} onChange={(e) => onToggle(item, e.target.checked)} /> 
                        </TableCell>
                      </TableRow>               
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </CardContent>
    </Card>
  );
};

export default BaselinesCard;